import React from 'react';
import AuthService from '../authService.js';
import GroupItem from '../../Domain/UserGroup/GroupItem.js';
import SearchParams from '../../Elements/SearchParams';
import GroupSearchParams from '../../Contents/Administration/UserGroups/GroupSearchParams';

export default class GroupService extends React.Component {
  static GetAllItemsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, GroupSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/UserGroup/GetItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new GroupItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static GetById(id) {
    const authService = AuthService.getInstance();
    const url = `/api/UserGroup/GetById/${id}`;
    return authService.CallBackendFunction(url);
  }

  static CreateNewGroup(newGroup) {
    const url = 'api/UserGroup/CreateNewGroup/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, JSON.stringify(newGroup));
  }

  static SaveEditedGroup(selectedItem) {
    const url = 'api/UserGroup/UpdateGroup/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, JSON.stringify(selectedItem));
  }
}
